import {Button} from "antd";

export interface RegStepFourProps {
  toDashboard: () => void;
}

export default function RegStepConfirm({toDashboard}: RegStepFourProps) {
  return (
    <div className={"success-next step full"}>
      <div className="emoji">&#127881;</div>
      <h2>Success!</h2>
      <p>We're excited you're here!<br/>
        Please chat with our team if you have any questions.</p>

      <footer>
        <Button size={"large"} className={"primary"} onClick={toDashboard}>Continue</Button>
      </footer>
    </div>
  );
}
